const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");
const trimLeadingSlash = (value) => String(value || "").replace(/^\/+/, "");

export const API_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_API_BASE_URL || "http://localhost/Shillongs/back-end/public"
);

export const APP_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_APP_BASE_URL || window.location.origin
);

export const apiUrl = (path = "") => {
  const cleanPath = trimLeadingSlash(path);
  return cleanPath ? `${API_BASE_URL}/${cleanPath}` : API_BASE_URL;
};

const apiConfig = {
  API_BASE_URL,
  APP_BASE_URL,
  apiUrl,
};

export default apiConfig;
